import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';

export default {
   config: function () {
      return Vue.bzbsConfig;
   },

   /**
   * Return Race
   */
   apiGetRaceBlob: function () {
      var url = `${this.config().bzbsBlobUrl}/config/bhpetrol/raceConfig.json`;
      return BzbsApi.connectBzbsGetBlob(url);
   },

   /**
   * Return Referal Code
   */
   apiGetReferralCodeBlob: function () {
      var url = `${this.config().bzbsBlobUrl}/config/bhpetrol/ReferralCode.json`;
      return BzbsApi.connectBzbsGetBlob(url);
   },

   apiVerifyRegister: function (params) {
      var url = `${this.config().bzbsModuleUrl}/auth/verify_register`;
      return BzbsApi.connectBzbsPost(url,null, params);
   },
}
